import React, { useRef, useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Templete from "../Templete/Templete";

import AuthService from "../../../services/Admin/AuthService";
import UserService from "../../../services/Admin/UserService";
import PackageService from "../../../services/Admin/PackageService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";
import { states } from "../../../utill/Common";

const AddUser = () => {
  const loadingCtx = useContext(LoadingContext);

  const [sessionUserType, setSessionUserType] = useState();

  React.useEffect(() => {
    getUserType();
    //  fetchUserList();
    fetchPackageList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUserType = () => {
    const _userType = AuthService.getUserType();
    setSessionUserType(_userType);
  };

  const [state, setState] = useState();
  const [userType, setUserType] = useState();

  const [UserList, setUserList] = useState();
  const [PackageList, setPackageList] = useState();

  const [packageId, setPackageId] = useState();
  const [gender, setGender] = useState();

  const [location, setLocation] = useState();

  const formRef = useRef();
  const domainNameRef = useRef();
  const panNumberRef = useRef();
  const nameRef = useRef();
  const shopNameRef = useRef();
  const dobRef = useRef();
  const mobileRef = useRef();
  const emailRef = useRef();
  const pincodeRef = useRef();
  const cityRef = useRef();
  const districtRef = useRef();
  const addressRef = useRef();

  const addUserHandler = async () => {
    let domainName;
    const panNumber = panNumberRef.current.value;
    const name = nameRef.current.value;
    const shopName = shopNameRef.current.value;
    const dob = dobRef.current.value;
    const mobile = mobileRef.current.value;
    const email = emailRef.current.value;
    const pincode = pincodeRef.current.value;
    const city = cityRef.current.value;
    const district = districtRef.current.value;
    const address = addressRef.current.value;

    if (!userType) {
      Swal.fire("Opps!", "Invalid User Type", "error");
      return;
    }

    if (userType == "Reseller" || userType == "Master Reseller") {
      domainName = domainNameRef.current.value;

      if (!domainName) {
        Swal.fire("Opps!", "Invalid Domain Name", "error");
        return;
      }
    }

    // if (!parentUserId) {
    //   Swal.fire("Opps!", "Invalid Parent", "error");
    //   return;
    // }

    // if (!packageId) {
    //   Swal.fire("Opps!", "Invalid Package", "error");
    //   return;
    // }

    if (!panNumber) {
      Swal.fire("Opps!", "Invalid PAN Number", "error");
      return;
    }

    if (!name) {
      Swal.fire("Opps!", "Invalid Name", "error");
      return;
    }

    if (!dob) {
      Swal.fire("Opps!", "Invalid Date of Birth", "error");
      return;
    }

    if (!gender) {
      Swal.fire("Opps!", "Invalid Gender", "error");
      return;
    }

    if (!mobile || mobile.length < 10 || mobile.length > 10) {
      Swal.fire("Opps!", "Invalid Mobile Number", "error");
      return;
    }

    if (!email) {
      Swal.fire("Opps!", "Invalid Email ID", "error");
      return;
    }

    if (!pincode) {
      Swal.fire("Opps!", "Invalid PIN Code", "error");
      return;
    }

    if (!state) {
      Swal.fire("Opps!", "Invalid State", "error");
      return;
    }

    if (!city) {
      Swal.fire("Opps!", "Invalid City", "error");
      return;
    }

    if (!district) {
      Swal.fire("Opps!", "Invalid District", "error");
      return;
    }

    if (!address) {
      Swal.fire("Opps!", "Invalid Address", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UserService.add(
        token,
        userType,
        domainName,
        packageId,
        panNumber,
        name,
        shopName,
        dob,
        gender,
        mobile,
        email,
        pincode,
        state,
        city,
        district,
        address
      );
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        formRef.current.reset();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const fetchPackageList = async () => {
    loadingCtx.startLoading();

    // const userId = props.userId ? props.userId : props.match.params.userId;

    try {
      const token = AuthService.getAccessToken();

      const responseData = await PackageService.fetchAll(token);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setPackageList(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const getLocationHandler = async (pincode) => {
    if (pincode.length < 6) {
      return;
    }

    loadingCtx.startLoading();

    // const userId = props.userId ? props.userId : props.match.params.userId;

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UserService.getLocation(token, pincode);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setLocation(responseData.data);
        setState(responseData.data ? responseData.data[0]["Circle"] : "");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Add User">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">Add User</h3>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <form ref={formRef} autoComplete="off">
                        <div class="card-body mt-2 mb-2">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              User Type
                            </label>
                            <div class="col-sm-9">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setUserType(e.target.value);
                                }}
                              >
                                <option value="">---Select User Type---</option>
                                <option value="Retailer">Retailer</option>
                                <option value="Distributor">Distributor</option>
                                <option value="Master Distributor">
                                  Master Distributor
                                </option>
                                <option value="Reseller">Reseller</option>
                                <option value="Master Reseller">
                                  Master Reseller
                                </option>
                                {/* <option value="Customer">Customer</option> */}
                              </select>
                            </div>
                          </div>

                          {(() => {
                            if (
                              userType == "Reseller" ||
                              userType == "Master Reseller"
                            ) {
                              return (
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">
                                    Domain Name
                                  </label>
                                  <div class="col-sm-9">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Domain Name"
                                      ref={domainNameRef}
                                    />
                                  </div>
                                </div>
                              );
                            }
                          })()}

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Select Package
                            </label>
                            <div class="col-sm-9">
                              <Autocomplete
                                options={PackageList}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select Package"
                                  />
                                )}
                                onChange={(e, v) => {
                                  setPackageId(v ? v.id : null);
                                }}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              PAN Number
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="PAN Number"
                                maxLength={10}
                                ref={panNumberRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Shop Name
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Business/Shop Name"
                                ref={shopNameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Name</label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="name"
                                class="form-control"
                                placeholder="Name"
                                ref={nameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Date of Birth
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="date"
                                class="form-control"
                                ref={dobRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Gender
                            </label>
                            <div class="col-sm-9">
                              <select
                                class="form-control"
                                onChange={(e) => {
                                  setGender(e.target.value);
                                }}
                              >
                                <option value="">---Select Gender---</option>
                                <option defaultValue="Male">Male</option>
                                <option defaultValue="Female">Female</option>
                                <option defaultValue="Transgender">
                                  Transgender
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Mobile Number
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="Mobile Number"
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                }}
                                ref={mobileRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Email ID
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="Email ID"
                                ref={emailRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              PIN Code
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="PIN Code"
                                maxLength={6}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                  getLocationHandler(e.target.value);
                                }}
                                ref={pincodeRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              >
                                <option
                                  value={location ? location[0]["Circle"] : ""}
                                >
                                  {location
                                    ? location[0]["Circle"]
                                    : "---Select State---"}
                                </option>

                                {states &&
                                  states.map((e, key) => {
                                    return (
                                      <option key={key} value={e.value}>
                                        {e.label}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="City"
                                ref={cityRef}
                                defaultValue={
                                  location ? location[0]["Region"] : ""
                                }
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              District
                            </label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                name="last_name"
                                class="form-control"
                                placeholder="District"
                                ref={districtRef}
                                defaultValue={
                                  location ? location[0]["District"] : ""
                                }
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                              Address
                            </label>
                            <div class="col-sm-9">
                              <textarea
                                ref={addressRef}
                                className="form-control"
                                placeholder="Address"
                                rows="3"
                              ></textarea>
                            </div>
                          </div>

                          <div class="card-footer text-center">
                            <button
                              type="button"
                              class="btn btn-primary"
                              onClick={addUserHandler}
                            >
                              Submit
                            </button>
                            <button type="reset" class="btn btn-default ml-5">
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default AddUser;
